import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';

import { FuseError403Component } from './error-403.component';

const routes = [
    {
        path     : 'pages/errors/error-403',
        component: FuseError403Component
    }
];

@NgModule({
    declarations: [
        FuseError403Component
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ]
})

export class Error403Module
{

}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/errors/403/error-403.module.ts